/*
 * Rollback: delete this file and remove the three <script>navigationGuard.init</script> lines from the three templates.
 */

(function() {
  'use strict';

  // Ensure namespace exists
  window.personalised = window.personalised || {};

  let overlay = null;
  let originalFocus = null;
  let isScrollLocked = false;
  let originalPaddingRight = '';
  let navigating = false; // rationale: prevent pre-nav hide

  function lockScroll() {
    if (!isScrollLocked) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      originalPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = (parseInt(originalPaddingRight) || 0) + scrollbarWidth + 'px';
      document.body.setAttribute('data-scroll-lock', 'true');
      document.body.style.overflow = 'hidden';
      isScrollLocked = true;
    }
  }

  function unlockScroll() {
    if (isScrollLocked) {
      document.body.style.paddingRight = originalPaddingRight;
      document.body.removeAttribute('data-scroll-lock');
      document.body.style.overflow = '';
      isScrollLocked = false;
    }
  }

  function trapFocus(element) {
    const focusableElements = element.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleTabKey(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    }

    element.addEventListener('keydown', handleTabKey);
    if (firstElement) firstElement.focus();

    return function removeTrap() {
      element.removeEventListener('keydown', handleTabKey);
    };
  }

  function show(message) {
    // Idempotent: reuse existing overlay if present
    if (overlay) return;

    // Ensure rotation keyframes exist
    if (!document.querySelector('#navguard-keyframes')) {
      const style = document.createElement('style');
      style.id = 'navguard-keyframes';
      style.textContent = '@keyframes rotation { from { transform: rotate(0deg); } to { transform: rotate(359deg); } }';
      document.head.appendChild(style);
    }

    // Ensure navguard styles exist
    if (!document.querySelector('#navguard-styles')) {
      const style = document.createElement('style');
      style.id = 'navguard-styles';
      // rationale: slow spinner to 4s for better UX
      style.textContent = '.navguard-overlay { background: rgb(250, 249, 246); } .navguard-content { display:flex; flex-direction:column; align-items:center; gap:12px; } .navguard-spinner { width:72px; height:72px; animation:rotation 4s infinite linear; } @media (min-width: 1024px) { .navguard-spinner { width:120px; height:120px; } .navguard-text { font-size:18px; } } .navguard-text { font-size:16px; font-weight:600; color:#1a1a1a; }';
      document.head.appendChild(style);
    }

    originalFocus = document.activeElement;
    
    const status = message || 'Loading your pack…';
    
    overlay = document.createElement('div');
    overlay.className = 'navguard-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:10010;display:flex;align-items:center;justify-content:center';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', status);

    const content = document.createElement('div');
    content.className = 'navguard-content';
    content.innerHTML = ''; // Harden against accidental reuse
    
    const spinner = document.createElement('img');
    spinner.className = 'navguard-spinner';
    spinner.src = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/LogoStamp.svg?v=1753343920';
    spinner.setAttribute('aria-hidden', 'true');
    
    content.appendChild(spinner);

    // rationale: dedupe text - ensure single status text, update if exists
    let textElement = content.querySelector('.navguard-text');
    if (!textElement) {
      textElement = document.createElement('p');
      textElement.className = 'navguard-text';
      content.appendChild(textElement);
    }
    textElement.textContent = status;
    
    overlay.appendChild(content);
    document.body.appendChild(overlay);
    
    lockScroll();
    const removeTrap = trapFocus(overlay);
    
    overlay._removeTrap = removeTrap;
  }

  function hide() {
    // rationale: prevent pre-nav hide - no-op while navigating
    if (navigating) return;
    
    if (!overlay) return;

    if (overlay._removeTrap) {
      overlay._removeTrap();
    }
    
    if (document.body.contains(overlay)) {
      document.body.removeChild(overlay);
    }
    overlay = null;
    
    unlockScroll();
    
    if (originalFocus) {
      originalFocus.focus();
      originalFocus = null;
    }
  }

  // Export to namespace
  window.personalised.modalSpinner = {
    show: show,
    hide: hide,
    setNavigating: function(value) { navigating = value; } // rationale: prevent pre-nav hide
  };
})();
